import { render, staticRenderFns } from "./TransitionSlide.vue?vue&type=template&id=89fad520"
import script from "./TransitionSlide.vue?vue&type=script&lang=js"
export * from "./TransitionSlide.vue?vue&type=script&lang=js"
import style0 from "./TransitionSlide.vue?vue&type=style&index=0&id=89fad520&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports